
import Rcslider from '~/kits/general/scripts/vendor/Slider';

require('rc-slider/assets/index.css');
import './slider.styl';

export default Rcslider;
